
  
<script>
import Layout from "../../../layouts/main";
import RequestQuoteList from "@/router/views/request-quote/supplier/request-quote-list";


export default {
  name: 'company',
  components: {Layout,RequestQuoteList},
  data() {
    return {
     
    };
  },

  mounted() {
  },

  methods: {

  },
};
</script>

<template>
  <Layout>
      <div class="row pt-4 p-sm-4">
      <div class="col-lg-12">
          <div class="card">
          <div class="card-body">
            <h2 class="card-title font-size-25 text-dark text-uppercase pt-2 pb-4" style="font-size:2em;">Demandes de devis</h2>
              <p class="card-title-desc font-size-14">
              </p>

              <RequestQuoteList/>
             
          </div>
          </div>
      </div>
      </div>
  </Layout>
</template>
